<template>
  <v-container fluid>
    <v-layout
      d-flex
      row
    >
      <v-flex
        md2
        offset-md2
      >
        <v-card
          class="title"
          color="green lighten-5"
        >
          <masked-input
            @keyup="keyup"
            type="text"
            name="heure"
            class="form-control"
            v-model="heure"
            :mask="[/[0-2]/, /[0-9]/]"
            :guide="true"
            placeholder-char="h"
          />
        </v-card>
      </v-flex>
      <v-flex md2>
        <v-card
          class="title"
          color="green lighten-5"
        >          
          <masked-input
            @keyup="keyup"
            type="text"
            name="minute"
            class="form-control"
            v-model="minute"
            :mask="[/[0-5]/, /[0-9]/]"
            :guide="true"
            placeholder-char="m"
          />
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex
        md4
        offset-md2
        v-if="isValid()"
      >
        <v-card class="title">
          <img :src="image">
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex
        md4
        offset-md2
        v-if="isValid()"
      >
        <v-card class="title">
          {{ heureToText }}
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import MaskedInput from 'vue-text-mask'

  export default {
    name: "Heure",

    components: {
      MaskedInput
    },
    computed: {
      image :{
        get(){
          return "https://moncahier.com/maths/image/image_pendule.php?heure="+this.heure+"&minute="+this.minute
        }
      },
    },
    data () {
      return {
        heure:null,
        minute:null,
        heureToText:'',
      }
    },
  methods: {
    isValid(){
      let h=parseInt(this.heure);
      let m=parseInt(this.minute);
      return h>=0 && h<24 && m>=0 && m<60;
    },
    keyup() {
      let h=parseInt(this.heure);
      let m=parseInt(this.minute);
      if(this.isValid()){
        this.heureToText=this.toHeure(h,m)
      }
    },
    /**
 * for heure:minute return the time to text.
 * 
 * @param {type} heure
 * @param {type} minute
 * @returns {temps|String}
 */
toHeure(heure, minute) {
    let plus="";
    if ((heure > 12 && heure < 23) || (heure == 12 && minute > 30) || (heure == 23 && minute <= 30)) {
        if (heure < 19) {
            plus = " de l'après midi.";
        } else {
            plus = " du soir.";
        }
    } else if ((heure == 11 && minute < 30) || (heure == 0 && minute > 30) || (heure < 11 && heure > 0)) {
        plus = " du matin.";
    }

    let temps = "Il est ";
    /* midi */
      let s='';
    if ((heure == 12 && minute <= 30) || (heure == 11 && minute > 30)) {
        temps += "midi ";
    }
    /* minuit */ else if ((heure == 0 && minute <= 30) || (heure == 23 && minute > 30)) {
        temps += "minuit ";
    }
    /* moins */ 
    else if (minute <= 30) {
        if ((heure % 12) > 1) {
            s = "s";
        } else {
            s = '';
        }
        temps += (heure % 12) + " heure"+s+" ";
    } else if (minute > 30) {
        if (((heure + 1) % 12) > 1) {
            s = "s";
        } else {
            s = '';
        }
        temps += ((heure + 1) % 12) + " heure"+s+" ";
    }
    if (minute < 1) {
        return temps;
        exit;
    } else if (minute == 15) {
        return temps +"et quart"+plus;
        exit;
    } else if (minute == 45) {
        return temps + "moins le quart"+plus;
        exit;
    } else if (minute == 30) {
        return temps + "et demi"+plus;
        exit;
    } else if (minute > 30) {
        return temps + "moins " + (60 - minute) + plus;
        exit;
    } else if (minute < 30) {
        return ""+temps + minute + plus;
        exit;
    }

    return temps;
},

/**
 * return (int)nombre into array 
 * @param {type} $nombre
 * @returns {u|String}
 */
rang(nombre) { //dispache les chiffres d'un nombre dans un tableau associatif
    nombre = ""+nombre;
    u = [];
    rang = ["bille", "boite", "valise", "caisse"];

    for(i=0;i < nombre.length;i++) {
        u[i] = nombre[i];
    }
    j=0;
    for (i = u.length - 1; i >= 0; i--) {
        u[rang[j]] = u[i];
        j++;
        delete (u[i]);
    } //mets dans un tableau associatif les valeurs chiffres de nombre.
    return(u);
}
  }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
